import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Lock } from "@phosphor-icons/react";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md rounded-lg border border-white/10 bg-white p-10">
        <div className="flex items-center gap-3">
          <div className="flex h-11 w-11 items-center justify-center rounded-md bg-navy text-gold"><Lock size={22} /></div>
          <div><div className="font-serif text-2xl text-navy">Admin Access</div><div className="overline text-gold-dark">Content Management</div></div>
        </div>
        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <div>
            <label className="mb-1.5 block text-[13px] font-medium text-navy/80">Email</label>
            <input data-testid="admin-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full rounded-md border border-slate-300 px-4 py-2.5 text-sm outline-none focus:border-gold" />
          </div>
          <div>
            <label className="mb-1.5 block text-[13px] font-medium text-navy/80">Password</label>
            <input data-testid="admin-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full rounded-md border border-slate-300 px-4 py-2.5 text-sm outline-none focus:border-gold" />
          </div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-600">{error}</p>}
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full rounded-md bg-navy px-4 py-3 text-sm font-semibold text-white hover:bg-navy-700 disabled:opacity-60">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
